import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        // Clear the hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Authentication failed");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-950 text-ink-50">
      <div className="text-center">
        <div className="data-label mb-3">Authenticating</div>
        <div className="flex items-center justify-center gap-2">
          <span className="block h-2 w-2 rounded-full bg-amber animate-pulse"></span>
          <span className="block h-2 w-2 rounded-full bg-amber animate-pulse [animation-delay:120ms]"></span>
          <span className="block h-2 w-2 rounded-full bg-amber animate-pulse [animation-delay:240ms]"></span>
        </div>
        {error && <div className="mt-4 text-sm text-red-400" data-testid="auth-callback-error">{error}</div>}
      </div>
    </div>
  );
}
